import { useMutation } from '@tanstack/react-query';
import { markSessionRead } from '@/hooks/conversations/use-mark-session-read';
import useConversationSessions from '@/hooks/sessions/use-conversation-sessions';
import { useConversationSessionStore } from '@/stores/conversation-session';
import { useMessageStore } from '@/stores/message';
import { addTranslateToast } from '@/stores/toast';
import { generateSessionKey } from '@/utils/session';

export default function useMarkAllSessionRead() {
  const { data } = useConversationSessions();

  return useMutation({
    mutationKey: ['/ReadChat'],
    mutationFn: async () => {
      if (!data) return;

      await Promise.allSettled(
        data
          .filter((session) => session.UnReadCount > 0)
          .map((session) =>
            markSessionRead({ type: session.SessionType, id: session.ID, messageId: 0, cause: 'all-sessions' }),
          ),
      );
    },
    onMutate: () => {
      if (data) {
        const { clearUnreadCount } = useConversationSessionStore.getState();

        for (const session of data) {
          if (session.UnReadCount <= 0) continue;
          const key = generateSessionKey(session.SessionType, session.ID);
          useMessageStore.getState().readAll(session.SessionType, session.ID);
          clearUnreadCount(key);
        }
      }
    },
    onSuccess: () => {
      addTranslateToast({
        type: 'success',
        message: 'conversation.read-all.success-message',
      });
    },
    onError: undefined,
  });
}
